import startCase from "lodash.startcase";
import toLower from "lodash.tolower";

import { setUser } from "@src/utils/setUser";

import { IgStorage } from "./igStorage";

export const sleep = async (time: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, time);
  });
};

export const toProperCaseWithSpaces = (value: string) => {
  return startCase(toLower(value.replace("_", " ")));
};

export const flattenObject = (ob: object) => {
  const toReturn = {};

  Object.keys(ob).map((i) => {
    // @ts-ignore
    if (typeof ob[i] === "object" && ob[i] !== null) {
      // @ts-ignore
      const flatObject = flattenObject(ob[i]);
      Object.keys(flatObject).map((x) => {
        // @ts-ignore
        toReturn[`${i}.${x}`] = flatObject[x];
        return x;
      });
    } else {
      // @ts-ignore
      toReturn[i] = ob[i];
    }
    return i;
  });
  return toReturn;
};

export const logoutWithWorker = () => {
  let logoutWorker: SharedWorker;
  try {
    logoutWorker = new SharedWorker("./workers/logout-worker.js", {
      type: "module",
      name: "Global Logout",
    });
    logoutWorker.port.postMessage({ type: "LOG_OUT" });
  } catch (e) {
    console.log(e);
  }
};

export const Logout = () => {
  console.log("Logout Received");
  IgStorage.clearAuthTokens();
  setUser(null);
  window.location.href = "/";
};

export const getAuthToken = () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams?.has("widgetAuth")) {
    return IgStorage.widgetToken;
  }

  if (!IgStorage.hasSessionLocalSync()) {
    logoutWithWorker();
    return null;
  }
  return urlParams?.get("auth") || IgStorage.authToken;
};
